const UploadMultiplePicturesSubDetails = ({ data }) => {
    const { action } = data;

    const titleObject = action.find((obj) => obj.name === 'Title');
    const descriptionObject = action.find((obj) => obj.name === 'Description');
    const minFilesObject = action.find((obj) => obj.name === 'MinFiles');

    return (
        <>
            <p className="flex gap-1 text-xs text-textSecondary mb-2  ">
                <span>Response type : </span>{' '}
                <span className="font-bold capitalize "> {data?.label?.split('_')?.join(' ')?.toLowerCase()}</span>
            </p>
            <p className="font-semibold capitalize text-textPrimary mb-2">
                <span>{titleObject?.value}</span>
            </p>
            <p className="text-sm capitalize text-textPrimary mb-2">
                <span>{descriptionObject?.value}</span>
            </p>
            <p className="text-sm capitalize text-textPrimary mb-2">
                <span> Minimum no. of photos - {minFilesObject?.value}</span>
            </p>
        </>
    );
};
export default UploadMultiplePicturesSubDetails;
